export class DocumentGroupCreationModel {
  ParentObjectName: string;
  ObjectId: string;
  PatientId: string;
  documentIds: string[];
}
